const API_BASE_URL = process.env.BASE_URL

export const CATALOG_ENDPOINTS = {
    CATALOGS: API_BASE_URL + "/{service_company_slug}/api/catalogs/",
    CATALOG_RESYNC: API_BASE_URL + "/{service_company_slug}/api/catalogs/{id}/resync/",
    BRANDS: API_BASE_URL + "/{service_company_slug}/api/brands/",
    BRAND_COUNT: API_BASE_URL + "/{service_company_slug}/api/brands/count/",
    CATEGORIES: API_BASE_URL + "/{service_company_slug}/api/categories/",
    ITEMS: API_BASE_URL + "/{service_company_slug}/api/items/",
    ITEMS_COUNT: API_BASE_URL + "/{service_company_slug}/api/items/count/",
    ITEM_DETAILS: API_BASE_URL + "/{service_company_slug}/api/items/{id}/",
    ITEM_MODIFIERS: API_BASE_URL + "/{service_company_slug}/api/items/{id}/modifiers/",
    SUBSCRIPTIONS: API_BASE_URL + "/{service_company_slug}/api/subscriptions/",
    SUBSCRIPTION_DETAILS: API_BASE_URL + "/{service_company_slug}/api/subscriptions/{id}/",
    SUBSCRIPTION_PREVIEW_COUNT: API_BASE_URL + "/{service_company_slug}/api/subscriptions/preview-count/",
    CATALOG_LINK_DISCONNECT: API_BASE_URL + "/{service_company_slug}/api/catalog-links/{id}/disconnect/",
    CATALOG_LINK_RECONNECT: API_BASE_URL + "/{service_company_slug}/api/catalog-links/{id}/reconnect/",
}
